import { useListStore } from "@/stores/lists";
import { DateTime } from "luxon";

import { CartData } from "@/types/supplier";
import { DELIVERY_TYPE } from "@/types/enum/order";
import { ORDER_DATE, ORDER_DATE_PICKUP } from "@/types/enum/supplierEnum";
import { Notification } from "@/types/notification";
import { NotificationTopic } from "@/types/enum/notification";
import { requiresPermission } from "@/functions/check";
import { PERMISSION_KEY } from "@/types/user";
import { useSupplierStore } from "@/stores/suppliers";

export const missingLocation = (): boolean => {
    const listStore = useListStore()
    return listStore.order.selectedDeliveryType === DELIVERY_TYPE.PICKUP && !listStore.order.pickupLocation;
}

const compareDateTime = (date: string): boolean => {
    const dateIso = DateTime.fromISO(date).toISO()
    const dayIso = DateTime.now().startOf('day').toISO()

    if (dateIso === null || dayIso === null) return false

    return dateIso < dayIso
}

export const missingTimingPickup = (cartData: CartData): boolean => {
    const listStore = useListStore()
    if (cartData.supplier.pickupTiming === ORDER_DATE_PICKUP.UNAVAILABLE) return false;

    const pickupDate = listStore.order.pickupDate

    if (!pickupDate) return true

    return compareDateTime(pickupDate)
}

export const missingTimingDelivery = (cartData: CartData): boolean => {
    const listStore = useListStore()
    if (cartData.supplier.deliveryTiming === ORDER_DATE.NOTHING) return false;

    const deliveryDate = listStore.order.deliveryDate

    if (!deliveryDate) return true

    return compareDateTime(deliveryDate)
}

export const showNotification = (notification: Notification): boolean => {
    if (notification.topic !== NotificationTopic.ORDER) return true

    return requiresPermission(PERMISSION_KEY.ORDER_HISTORY_READ)
}

export const isCatalogCached = (supplierId: string | undefined, listId?: string | undefined): boolean => {
    const supplierStore = useSupplierStore()
    if (!supplierId) return false

    if (typeof listId !== 'string' && !listId) return !!supplierStore.catalog[supplierId]

    return !!supplierStore.listCatalog[supplierId] && !!supplierStore.listCatalog[supplierId][listId]
}

export const isListItemsCached = (listId: string | undefined): boolean => {
    const listStore = useListStore()
    if (!listId) return false

    return !!listStore.listItems[listId]
}

export const isSpecialOffersCached = (supplierId: string | undefined): boolean => {
    const supplierStore = useSupplierStore()
    if (!supplierId) return false

    return !!supplierStore.specialOffers[supplierId]
}
